<template
  ><!-- 下单有礼 复购 shougou -->
  <div class="pointStep">
    <!--  活动条件表单部分 -->
    <div class="pointset">积分基础设置</div>
    <el-form :model="basicsForm" ref="basicsForm" class="backgroundForm" label-width="120px">
      <el-form-item label="积分名称：">
        <el-input v-model="basicsForm.pointName" maxlength="5" show-word-limit placeholder="请填入" style="width: 150px"></el-input>
      </el-form-item>
      <el-form-item label="交易积分：">
        每成功交易
        <el-input @input="basicsForm.successOnePointMoney = getNumberData2(1,$event,1,0)" v-model="basicsForm.successOnePointMoney" placeholder="请填入" style="width: 80px"></el-input> 元获得1积分，单笔上限
        <el-input @input="handlePositiveIntegerInput($event, 'basicsForm','perLimitPoint')" v-model="basicsForm.perLimitPoint" placeholder="请填入" style="width: 80px"></el-input> 积分
        <div style="color:#F9724A">
          （注：交易未达到金额将不会获得积分）
        </div>
      </el-form-item>
      <el-form-item label="发放范围：">
        <el-radio v-model="basicsForm.scope" :label="1">仅针对入会会员发放</el-radio>
        <el-radio v-model="basicsForm.scope" :label="2">未入会客户也发放</el-radio>
      </el-form-item>
      <el-form-item label="积分有效期：">
        <el-radio v-model="basicsForm.validDateType" :label="1">积分获得之日</el-radio>
        <el-input @input="handlePositiveIntegerInput($event, 'basicsForm','validDate')" v-model="basicsForm.validDate" placeholder="请填入" style="width: 80px;margin-left: -23px;"></el-input>
        <span style="margin-right:30px"> 天后过期</span>
        <el-radio v-model="basicsForm.validDateType" :label="2">积分获得后</el-radio>
        <el-select v-model="basicsForm.year" placeholder="请选择" style="width: 80px;margin-left: -23px;">
          <el-option label="当年" value="0"></el-option>
          <el-option label="一年" value="1"></el-option>
          <el-option label="两年" value="2"></el-option>
          <el-option label="三年" value="3"></el-option>
        </el-select>
        &nbsp;后&nbsp;
        <el-select v-model="basicsForm.mon" placeholder="请选择" style="width: 80px">
          <el-option v-for="item in monList" :key="item" :label="`${item}月`" :value="item"></el-option> </el-select
        >&nbsp;
        <el-select v-model="basicsForm.day" placeholder="请选择" style="width: 80px">
          <el-option v-for="item in dayList" :key="item" :label="`${item}号`" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="排除商品：">
        <div class="pcShop" @click="selectGoodsState = true">添加排除商品</div>
        <draggable
          v-if="mainImagelist.length > 0"
          v-model="mainImagelist"
          chosen-class="chosen"
          :scroll="true"
          animation="150"
          force-fallback="true"
          @start="isDragging = true"
          @end="onEnd"
          class="draggBox"
          style="margin-top: 10px;"
        >
          <transition-group type="transition">
            <div
              v-for="(item, index) in mainImagelist"
              :key="item.skuId"
              style="display: inline-block; position: relative;margin-right: 10px;"
              class="show_upImg2"
            >
              <img :src="item.logo" width="120px" height="120px" style="display: inline-block" />&nbsp;
              <!-- <div @click.stop="delec(index)" class="delectPosible">
                <i class="el-icon-circle-close" style="font-size: 16px"></i>
              </div> -->
              <div class="delectPosible">
                <span class="delectSort">拖动排序</span>
                <img src="@/assets/thdImg/pages/delet.svg" @click.stop="delec(item, index)" class="delectIcom" />
              </div>
            </div>
          </transition-group>
        </draggable>
      </el-form-item>
      <el-form-item>
        <el-button class="keepBtn" type="primary" size="medium" @click="saveEdit(1)">保存设置</el-button>
      </el-form-item>
    </el-form>
    <!--  -->
    <div class="pointset">积分奖励规则</div>
    <el-form :model="ruleForm" ref="ruleForm" class="backgroundForm" label-width="120px">
      <el-form-item label="入会得积分：">
        会员首次入会后赠送 <el-input @input="handlePositiveIntegerInput($event, 'ruleForm','joinPoint')" v-model="ruleForm.joinPoint" placeholder="请填入" style="width: 80px"></el-input> 积分
        <div style="color:#F9724A">
          （注：设置为0则不送积分）
        </div>
      </el-form-item>
      <el-form-item label="会员日权益：">
        <el-switch v-model="ruleForm.memberDayStatus"></el-switch>
        <div style="margin:12px 0">
          会员日时间：每月
          <el-input v-model="memberDayStart" placeholder="请填入" style="width: 80px" @input="changeMemberDay"></el-input>
          <span style="margin:0 10px;">-</span>
          <el-input v-model="memberDayEnd" placeholder="请填入" style="width: 80px" @input="changeMemberDay"></el-input>
          号
        </div>
        <el-checkbox v-model="ruleForm.memberDayGiveStatus">会员日额外赠送积分</el-checkbox>&nbsp;<el-input
          v-model="ruleForm.memberDayGiveMultiple"
          @input="handlePositiveIntegerInput2($event, 'ruleForm','memberDayGiveMultiple')"
          placeholder="请填入"
          style="width: 80px"
        ></el-input>
        倍
      </el-form-item>
      <!-- <el-form-item label="升级送积分：">
        会员升级后赠送 <el-input v-model="ruleForm.levelUpPoint" placeholder="请填入" style="width: 80px"></el-input> 积分
      </el-form-item> -->
      <el-form-item label="特殊场景奖励：">
        <el-button type="primary" size="medium" @click="handleInfo()">添加规则</el-button>
        <div class="rulebox" v-for="(item, index) in ruleList" :key="index" style="color:#333">
          <div class="rulebox_flex">
            <span class="rulebox_flex_left">下单时间：</span>
            <span>{{ item.orderTime[0] }} ~ {{ item.orderTime[1] }}</span>
            <div style="margin-left:auto;display: flex;">
              <div class="btn_edit pointer" @click="handleRuleEdit(item, index)">修改</div>
              <div class="btn_edit btn_del pointer" @click="handleRuleDel(item, index)">删除</div>
            </div>
          </div>
          <div class="rulebox_flex">
            <span class="rulebox_flex_left">单笔金额：</span>
            <span>{{ item.moneyType == 1 ? "单笔金额" : "按天积累" }}大于{{ item.eachReachMoney }}元</span>
          </div>
          <div class="rulebox_flex">
            <span class="rulebox_flex_left">奖励倍数：</span>
            <span>{{ item.awardMultiple }}倍积分</span>
          </div>
          <div class="rulebox_flex">
            <span class="rulebox_flex_left">浏览商品：</span>
            <span class="rulebox_flex_btn">已选{{ item.specialAwardList.length }}个</span>
          </div>
          <div class="rulebox_flex" style="flex-wrap: wrap;">
            <div
              v-for="(item1, index1) in item.specialAwardList"
              :key="index1"
              style="display: inline-block; position: relative;margin-right: 10px;"
              class="show_upImg2"
            >
              <img :src="item1.picUrl" width="120px" height="120px" style="display: inline-block" />
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button class="keepBtn" type="primary" size="medium" @click="saveEdit(2)">保存设置</el-button>
      </el-form-item>
    </el-form>
    <!-- 添加曝光商品 -->
    <selectGoodsMonitor v-if="selectGoodsState" @transferName="selectGoodsClose" :postForm="selectGoodsArr" :maxNum="20"> </selectGoodsMonitor>

    <!-- 选择商品弹窗 -->
    <el-dialog title="奖励规则" :visible.sync="dialogFormVisible" width="570px">
      <div class="rulebox" style="background:#fff;margin-top:0;padding:0;width:550px;min-height: 254px;">
        <div class="rulebox_flex">
          <span class="rulebox_flex_left">下单时间：</span>
          <div>
            <div class="my_select_time">
              <el-date-picker
                v-model="dialogItem.orderTime"
                type="daterange"
                class="rangeTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                ref="timeBox"
                style="width: 400px; font-size: 12px"
              >
              </el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="dialogItem.orderTime = []"></i>
              <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
            </div>
          </div>
        </div>
        <div class="rulebox_flex">
          <span class="rulebox_flex_left">单笔金额：</span>
          <div>
            <el-select v-model="dialogItem.moneyType" placeholder="请选择" style="width: 80px;">
              <el-option label="单笔金额" value="1"></el-option>
              <el-option label="按天积累" value="2"></el-option> </el-select
            >&nbsp;大于&nbsp; <el-input v-model="dialogItem.eachReachMoney" placeholder="请填入" style="width: 80px"></el-input> 元
          </div>
        </div>
        <div class="rulebox_flex">
          <span class="rulebox_flex_left">奖励倍数：</span>
          <div><el-input v-model="dialogItem.awardMultiple" placeholder="请填入" style="width: 80px"></el-input> 倍积分</div>
        </div>
        <div class="rulebox_flex">
          <span class="rulebox_flex_left">指定商品：</span>
          <span class="rulebox_flex_btn" @click="selectGoodsStateFilter = true">{{
            dialogItem.specialAwardList.length == 0 ? "请选择" : "已选" + dialogItem.specialAwardList.length + "个"
          }}</span>
        </div>
        <div class="rulebox_flex" style="justify-content: center;">
          <div class="createAdd_qx pointer" @click="dialogFormVisible = false">取消</div>
          <div class="createAdd_save pointer" @click="handleSave">确定</div>
        </div>
      </div>
    </el-dialog>
    <!-- 指定购买商品 -->
    <selectGoods v-if="selectGoodsStateFilter" @transferName="selectGoodsCloseFilter" :postForm="dialogItem.specialAwardList" :maxNum="20">
    </selectGoods>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
// import SelectGoods from "../../components/selectGoodsMonitor";
import { mapState, mapMutations } from "vuex";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import draggable from "vuedraggable";
import selectGoods from "@/components/select-goods2.vue";
import { pointRuleConfig, getPointRuleConfig } from "@/api/thd.js";
export default {
  components: {
    // SelectGoods,
    selectGoodsMonitor,
    draggable,
    selectGoods,
  },

  computed: {
    ...mapState(["venderType"]),
  },
  data() {
    return {
      memberDayStart: "",
      memberDayEnd: "",
      ruleIndex: 0,
      ruleIsflay: false, // false新增，true修改
      dialogFormVisible: false,
      dialogItem: {
        eachReachMoney: "",
        orderTime: [],
        moneyType: "",
        awardMultiple: "",
        specialAwardList: [],
      },
      ruleList: [],
      monList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      dayList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
      selectGoodsState: false,
      isDragging: false,
      mainImagelist: [],
      itemListFor: [],
      selectGoodsArr: [],
      selectGoodsStateFilter: false,
      ruleForm: {
        //设置规则表单
        joinPoint: "",
        // levelUpPoint: "",
        memberDay: "",
        memberDayGiveMultiple: "",
        memberDayGiveStatus: false,
        memberDayStatus: false,
      },
      basicsForm: {
        //设置基础表单
        pointName: "",
        perLimitPoint: "",
        successOnePointMoney: "",
        validDate: "",
        validDateType: 1,
        scope: 1,
        year: "",
        mon: "",
        day: "",
      },
      id: "",
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const { data: res } = await getPointRuleConfig();
      this.id = res.id;
      // 积分奖励规则awardSettings
      this.ruleForm.joinPoint = res.awardSettings.joinPoint;
      // this.ruleForm.levelUpPoint = res.awardSettings.levelUpPoint;
      // this.ruleForm.memberDay = res.awardSettings.memberDay;
      if (res.awardSettings.memberDay && res.awardSettings.memberDay.toString().indexOf("~") !== -1) {
        this.memberDayStart = res.awardSettings.memberDay.split("~")[0];
        this.memberDayEnd = res.awardSettings.memberDay.split("~")[1];
      } else {
        this.memberDayStart = res.awardSettings.memberDay ? res.awardSettings.memberDay : "";
        this.memberDayEnd = res.awardSettings.memberDay ? res.awardSettings.memberDay : "";
      }
      this.ruleForm.memberDayGiveMultiple = res.awardSettings.memberDayGiveMultiple;
      this.ruleForm.memberDayGiveStatus = res.awardSettings.memberDayGiveStatus == 0 || !res.awardSettings.memberDayGiveStatus ? false : true;
      this.ruleForm.memberDayStatus = res.awardSettings.memberDayStatus == 0 || !res.awardSettings.memberDayStatus ? false : true;
      this.ruleList = res.awardSettings.specialAwardList
        ? res.awardSettings.specialAwardList.map((item) => {
            return {
              ...item,
              orderTime: item.orderStartTime ? [item.orderStartTime, item.orderEndTime] : ["", ""],
              specialAwardList: item.specialAwardList
                ? item.specialAwardList.map((i) => {
                    return {
                      ...i,
                      logo: i.picUrl,
                      skuId: i.numIid,
                      itemTitle: i.title || i.itemTitle,
                    };
                  })
                : [],
            };
          })
        : [];
      // 积分基础设置baseSettings
      this.itemListFor = res.baseSettings.excludeItemList
        ? res.baseSettings.excludeItemList.map((item) => {
            return {
              ...item,
              logo: item.picUrl,
              skuId: item.numIid,
              itemTitle: item.title || item.itemTitle,
            };
          })
        : [];
      this.mainImagelist = this.itemListFor;
      this.selectGoodsArr = this.itemListFor;

      this.basicsForm.pointName = res.baseSettings.pointName;
      this.basicsForm.perLimitPoint = res.baseSettings.perLimitPoint;
      this.basicsForm.successOnePointMoney = res.baseSettings.successOnePointMoney;

      if (res.baseSettings.validDateType == 2) {
        let arr = res.baseSettings.validDate ? res.baseSettings.validDate.split("-") : ["", "", ""];
        this.basicsForm.year = arr[0];
        this.basicsForm.mon = arr[1] * 1;
        this.basicsForm.day = arr[2] * 1;
      }

      this.basicsForm.scope = res.baseSettings.scope ? res.baseSettings.scope : 1;
      console.log(this.basicsForm.validDate, 6666);
      this.basicsForm.validDate = res.baseSettings.validDateType == 1 ? res.baseSettings.validDate : "";
      this.basicsForm.validDateType = res.baseSettings.validDateType ? res.baseSettings.validDateType : 1;
      console.log(res, 99999);
    },
    changeMemberDay() {
      this.memberDayStart = this.memberDayStart.replace(/[^\d]/g, '').replace(/^0+/, '')
      if (this.memberDayStart > 31) {
        this.memberDayStart = 31;
      } else if (this.memberDayStart < 0) {
        this.memberDayStart = 31;
      }
      this.memberDayEnd = this.memberDayEnd.replace(/[^\d]/g, '').replace(/^0+/, '')
      if (this.memberDayEnd > 31) {
        this.memberDayEnd = 31;
      } else if (this.memberDayEnd < 0) {
        this.memberDayEnd = 0;
      }
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },
    //删除
    delec(item, index) {
      let i = -1;
      this.mainImagelist.forEach((items, index1) => {
        if (items.skuId == item.skuId) i = index1;
      });
      if (i != -1) {
        this.mainImagelist.splice(i, 1);
        this.itemListFor = this.mainImagelist;
        // this.itemListFor.splice(i, 1);
      }
      console.log(this.mainImagelist, 4444444);
    },
    selectGoodsClose(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;
        // event.forEach((item) => {
        //   newArr.push(item.numIid);
        // });
        if (index && index == 1) {
          this.itemListFor = newArr;
          this.mainImagelist = newArr;
          this.selectGoodsArr = newArr;
        }
      }
      this.selectGoodsState = false;
    },
    handleInfo() {
      this.dialogFormVisible = true;
      this.ruleIsflay = false;
      this.dialogItem.eachReachMoney = "";
      this.dialogItem.orderTime = [];
      this.dialogItem.moneyType = "";
      this.dialogItem.awardMultiple = "";
      this.dialogItem.specialAwardList = [];
    },
    //选择商品数据 曝光
    selectGoodsCloseFilter(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;
        if (index && index == 1) {
          this.dialogItem.specialAwardList = newArr.map((item) => {
            return {
              numIid: item.numIid,
              picUrl: item.picUrl,
              price: item.price,
              itemTitle: item.itemTitle,
            };
          });
        }
      }
      // console.log(this.dialogItem);
      this.selectGoodsStateFilter = false;
    },
    async saveEdit(num) {
      console.log(this.basicsForm);
      let params = {};
      if (num == 1) {
        params = {
          id: this.id,
          baseSettings: {
            pointName: this.basicsForm.pointName,
            perLimitPoint: this.basicsForm.perLimitPoint,
            successOnePointMoney: this.basicsForm.successOnePointMoney,
            // memberDayGiveStatus: this.basicsForm.memberDayGiveStatus,
            validDate:
              this.basicsForm.validDateType == 1
                ? this.basicsForm.validDate
                : `${this.basicsForm.year}-${this.basicsForm.mon}-${this.basicsForm.day}`,
            validDateType: this.basicsForm.validDateType,
            scope: this.basicsForm.scope,
            excludeItemList: this.itemListFor.map((item) => {
              return {
                numIid: item.numIid,
                picUrl: item.picUrl,
                price: item.price,
                itemTitle: item.itemTitle,
                title: item.title,
              };
            }),
          },
        };
        console.log(params, 88888888);
      }
      if (num == 2) {
        this.ruleForm.memberDay = this.memberDayStart + "~" + this.memberDayEnd;
        params = {
          id: this.id,
          awardSettings: {
            joinPoint: this.ruleForm.joinPoint,
            // levelUpPoint: this.ruleForm.levelUpPoint,
            memberDay: this.ruleForm.memberDay,
            memberDayGiveMultiple: this.ruleForm.memberDayGiveMultiple,
            memberDayGiveStatus: this.ruleForm.memberDayGiveStatus ? 1 : 0,
            memberDayStatus: this.ruleForm.memberDayStatus ? 1 : 0,
            specialAwardList: this.ruleList.map((item) => {
              return {
                awardMultiple: item.awardMultiple,
                moneyType: item.moneyType,
                eachReachMoney: item.eachReachMoney,
                specialAwardList: item.specialAwardList,
                orderStartTime: item.orderTime[0],
                orderEndTime: item.orderTime[1],
              };
            }),
          },
        };
      }
      const res = await pointRuleConfig(params);
      if (res.code == 1) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
      console.log(res, 6666);
    },
    handleRuleEdit(item, index) {
      this.dialogItem = item;
      this.ruleIndex = index;
      this.ruleIsflay = true;
      this.dialogFormVisible = true;
    },
    handleRuleDel(item, index) {
      this.ruleList.splice(index, 1);
    },
    handleSave() {
      if (this.dialogItem.orderTime.length == 0) return this.$message.warning("请选择下单时间");
      if (!this.dialogItem.eachReachMoney || !this.dialogItem.moneyType) return this.$message.warning("请填写单笔金额");
      if (!this.dialogItem.awardMultiple) return this.$message.warning("请填写奖励倍数");
      if (this.dialogItem.specialAwardList.length == 0) return this.$message.warning("请选择浏览商品");
      if (this.ruleIsflay) {
        this.ruleList.splice(this.ruleIndex, 1, this.dialogItem);
      } else {
        this.ruleList.push(this.dialogItem);
      }
      console.log(this.ruleList);
      this.dialogFormVisible = false;
    },
    //输入框限制负数
    checkputn(e, num = "-1") {
      if (num == "0") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        if (e.target.value < 1) {
          e.target.value = "";
        }
      }

      if (num == "1") {
        let filtered = e.target.value
          .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3")
          .replace(/\.{2,}/g, ".")
          .replace(/[^\d.]/g, "");
        e.target.value = filtered;
        // if (e.target.value < 1) {
        //   e.target.value = "";
        // }
      }
    },
    handlePositiveIntegerInput(value, field, field2) {
      // 过滤非数字字符，并去除前导零
      const filteredValue = value.replace(/[^\d]/g, '').replace(/^0+/, '')
      this[field][field2] = filteredValue
    },
    // 可以输入一位小数
    handlePositiveIntegerInput2(value, field, field2) {
      let filteredValue = value.replace(/[^\d.]/g, "").replace(/^0+/, "");
      // 确保整个字符串中只保留第一个小数点
      const firstDotIndex = filteredValue.indexOf(".");
      if (firstDotIndex !== -1) {
        // 将第一个小数点后的所有小数点都移除
        const beforeDot = filteredValue.substring(0, firstDotIndex + 1);
        const afterDot = filteredValue.substring(firstDotIndex + 1).replace(/\./g, "");
        filteredValue = beforeDot + afterDot;
      }
      // 确保小数点不在开头
      filteredValue = filteredValue.replace(/^\./, "");
      
      // 确保只保留一位小数
      if (filteredValue.includes(".")) {
        const parts = filteredValue.split(".");
        if (parts[1].length > 1) {
          filteredValue = parts[0] + "." + parts[1].slice(0, 1);
        }
      }
      this[field][field2] = filteredValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.pointStep {
  .btn_edit {
    width: 44px;
    height: 28px;
    background: #ffffff;
    color: #666666;
    text-align: center;
    line-height: 28px;
    margin-right: 10px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    &:hover {
      border: 1px solid #2670fb;
      color: #2670fb;
    }
  }
  .btn_del {
    &:hover {
      border: 1px solid red;
      color: red;
    }
  }
  .draggBox {
    background: rgba(38, 112, 251, 0.06);
    border-radius: 8px;
    padding: 10px 10px 0 10px;
  }
  .pointset {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    &::before {
      content: "";
      width: 2px;
      height: 14px;
      background: #2670fb;
      border-radius: 2px;
      margin-right: 5px;
    }
  }
  .pcShop {
    color: #2670fb;
    width: 108px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    background: rgba(38, 112, 251, 0.1);
    border-radius: 4px;
    opacity: 1;
    border: 1px solid #2670fb;
    margin-bottom: 16px;
    &:hover {
      color: #fff;
      background: #2670fb;
    }
  }
  .keepBtn {
    margin: 20px 0 40px 0;
  }
  .rulebox {
    width: 750px;
    min-height: 300px;
    background: #f8f9ff;
    border-radius: 8px;
    margin-top: 10px;
    padding: 24px;
    &_flex {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      &_left {
        width: 80px;
      }
      &_btn {
        padding: 0px 10px;
        height: 32px;
        color: #2670fb;
        line-height: 32px;
        background: rgba(38, 112, 251, 0.1);
        border-radius: 4px;
        border: 1px solid #2670fb;
      }
    }
    .createAdd_save {
      margin-top: 24px;
      width: 100px;
      height: 32px;
      background: #2670fb;
      margin-right: 20px;
      border-radius: 4px;
      color: #fff;
      line-height: 32px;
      text-align: center;
      &:hover {
        opacity: 0.8;
      }
    }
    .createAdd_qx {
      margin-top: 24px;
      width: 100px;
      height: 32px;
      background: #fff;
      margin-right: 20px;
      border-radius: 4px;
      color: #606266;
      line-height: 32px;
      text-align: center;
      border: 1px solid #dddddd;
      &:hover {
        color: #fff;
        background: #2670fb;
        border: 1px solid #2670fb;
      }
    }
  }
}
</style>
